/* SmartHeart homepage (hp-* sections) */
(function(){
  if (window.__hpHome) return; window.__hpHome = true;
  var design = !!(window.Shopify && window.Shopify.designMode);
  var io = null;

  function reveal(root){
    var els = root.querySelectorAll('.hp-reveal:not(.hp-seen)');
    if (design || !('IntersectionObserver' in window)) { els.forEach(function(el){ el.classList.add('hp-seen'); }); return; }
    if (!io) io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if (e.isIntersecting){ e.target.classList.remove('hp-pending'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    var vh = window.innerHeight || 800;
    els.forEach(function(el){
      el.classList.add('hp-seen');
      if (el.getBoundingClientRect().top > vh) { el.classList.add('hp-pending'); io.observe(el); }
    });
  }

  function videos(root){
    root.querySelectorAll('[data-hp-video]:not([data-hp-bound])').forEach(function(box){
      box.setAttribute('data-hp-bound','1');
      function play(){
        if (box.classList.contains('hp-playing')) return;
        var v = document.createElement('video');
        v.src = box.getAttribute('data-hp-video'); v.controls = true; v.autoplay = true; v.playsInline = true;
        v.setAttribute('playsinline',''); v.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;background:#000';
        if (box.classList.contains('hp-hiw__media')) v.style.position = 'static', v.style.aspectRatio = '4/3.3';
        var img = box.querySelector('img'); if (img) img.replaceWith(v); else box.prepend(v);
        box.classList.add('hp-playing', 'playing');
      }
      box.addEventListener('click', play);
      box.addEventListener('keydown', function(e){ if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); play(); } });
    });
  }

  function nav(root){
    root.querySelectorAll('[data-hp-nav]:not([data-hp-bound])').forEach(function(h){
      h.setAttribute('data-hp-bound','1');
      var btn = h.querySelector('.hp-menu-toggle'), menu = btn && document.getElementById(btn.getAttribute('aria-controls'));
      if (!btn || !menu) return;
      btn.addEventListener('click', function(){
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true'); menu.hidden = open;
      });
      menu.addEventListener('click', function(e){ if (e.target.closest('a')) { btn.setAttribute('aria-expanded','false'); menu.hidden = true; } });
    });
  }

  function practices(root){
    root.querySelectorAll('[data-hp-practices]:not([data-hp-bound])').forEach(function(grid){
      grid.setAttribute('data-hp-bound','1');
      var panel = grid.querySelector('.hp-prac-detail');
      var items = [].slice.call(grid.querySelectorAll('.hp-prac-item'));
      var current = null;
      if (!panel) return;
      function rowEnd(item){ var top = item.offsetTop, last = item; items.forEach(function(it){ if (Math.abs(it.offsetTop - top) < 4) last = it; }); return last; }
      function label(item, open){
        var b = item.querySelector('.hp-prac'), l = item.querySelector('.hp-prac__more-label');
        b.setAttribute('aria-expanded', open ? 'true' : 'false'); item.classList.toggle('hp-is-open', open);
        if (l) l.textContent = open ? l.getAttribute('data-open') : l.getAttribute('data-closed');
      }
      function place(item){
        rowEnd(item).after(panel);
        var g = grid.getBoundingClientRect(), r = item.getBoundingClientRect();
        panel.style.setProperty('--notch-x', (r.left - g.left + r.width / 2) + 'px');
      }
      function open(item, noScroll){
        var long = item.querySelector('.hp-prac__long'); if (!long) return;
        if (current) label(current, false);
        current = item;
        var src = item.querySelector('.hp-prac__img');
        var pimg = panel.querySelector('.hp-prac-detail__img');
        if (src && src.tagName === 'IMG') { pimg.src = src.currentSrc || src.src; pimg.style.display = ''; } else { pimg.style.display = 'none'; }
        panel.querySelector('.hp-prac-detail__title').innerHTML = item.querySelector('.hp-prac__title').innerHTML;
        panel.querySelector('.hp-prac-detail__content').innerHTML = long.innerHTML;
        panel.setAttribute('aria-labelledby', item.querySelector('.hp-prac').id);
        panel.classList.remove('hp-is-open'); panel.hidden = false;
        place(item); label(item, true);
        void panel.offsetHeight; panel.classList.add('hp-is-open');
        if (!noScroll) setTimeout(function(){
          var pr = panel.getBoundingClientRect();
          if (pr.bottom > window.innerHeight - 80) window.scrollBy({ top: Math.min(pr.bottom - window.innerHeight + 100, pr.top - 120), behavior: 'smooth' });
        }, 320);
      }
      function close(){
        if (!current) return;
        var b = current.querySelector('.hp-prac');
        label(current, false); panel.classList.remove('hp-is-open'); panel.hidden = true; current = null;
        b.focus({ preventScroll: true });
      }
      items.forEach(function(item){
        var b = item.querySelector('.hp-prac');
        if (!item.querySelector('.hp-prac__long .hp-rte') || !item.querySelector('.hp-prac__long .hp-rte').textContent.trim()) { b.style.cursor = 'default'; return; }
        b.addEventListener('click', function(){ current === item ? close() : open(item); });
      });
      panel.querySelector('.hp-prac-detail__close').addEventListener('click', close);
      document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && current) close(); });
      var rt; window.addEventListener('resize', function(){ clearTimeout(rt); rt = setTimeout(function(){ if (current) place(current); }, 120); });
      grid.__hpOpen = function(blockId){ var it = grid.querySelector('[data-block-id="' + blockId + '"]'); if (it) open(it, true); };
    });
  }

  function init(root){ reveal(root); videos(root); nav(root); practices(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
  document.addEventListener('shopify:block:select', function(e){
    var grid = e.target.closest && e.target.closest('[data-hp-practices]');
    if (grid && grid.__hpOpen) grid.__hpOpen(e.detail.blockId);
  });
})();
